import { File } from "lucide-react";

interface DocumentationItem {
  name: string;
  url: string;
}

interface DocumentationListProps {
  documentation: DocumentationItem[];
  className?: string;
}

export const DocumentationList = ({ documentation, className = "" }: DocumentationListProps) => {
  return (
    <div className={`mb-4 ${className}`}>
      <span className="text-sm font-medium mb-2 block">Documentation</span>
      {!documentation || documentation.length === 0 ? (
        <div className="text-sm text-gray-500 italic">
          No documentation uploaded
        </div>
      ) : (
        <div className="space-y-3">
          {documentation.map((doc, index) => (
            <div key={index} className="flex items-center gap-3 text-sm text-gray-600">
              <File className="h-4 w-4" />
              <a
                href={doc.url}
                download
                className="hover:underline cursor-pointer"
              >
                {doc.name}
              </a>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
